import { Box, Button, Stack, TextField } from "@mui/material"
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min"
import { useEffect, useState } from "react"
import { env } from "../../../../core/Env"
import { rqx } from "../../../../core/request/API"
import List from './List'
import Setup from "./Setup"

function useQuery() {
    return new URLSearchParams(useLocation().search)
}
export const Contact = ({tool_state}) => {
    const history = useHistory()
    const urlParams = useQuery();
    const { __SESSION } = tool_state
    // STATE
    const [add, setAdd] = useState(false)
    const [list, setList] = useState([])
    const [listLoader, setListLoader] = useState(false)
    const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(true)
    const [totalList, setTotalList] = useState(0)
    const [search, setSearch] = useState('')
    const [form, setForm] = useState({
        email: '', 
        last_name: '', 
        first_name: '', 
        contact_no:'', 
        birthdate: '', 
        company_name: '',
        address: '',
        error: false,
        confirmation: false,
        btnLoader: false,
        method: 'create',
    })
    const dfltForm = { email: '',  last_name: '',  first_name: '',  contact_no:'',  birthdate: '',  company_name: '', address: '', error: false, confirmation: false, btnLoader: false, method: 'create', }

    const btnSubFt = [
        {name: 'Product', url: 'product'},
        {name: 'Booking', url: 'booking'},
        {name: 'Real Property', url: 'real-property'},
        {name: 'Training', url: 'training'},
        {name: 'Membership', url: 'membership'},
    ]

    const subft = urlParams.get('subft') || 'product';
    const subtype = urlParams.get('subft') === 'product' ? 1 : urlParams.get('subft') === 'booking' ? 2 : urlParams.get('subft') === 'real-property' ? 3 : urlParams.get('subft') === 'training' ? 4 : 5
    const handleBtns = (type) => {
        history.push(`?subft=${type}`)
    }

    const handleAdd = () => {
        setAdd(true)
        setForm(dfltForm)
    }

    const isActive = (val) => subft === val;
    const btnStyle = (btn) => ({
        color: isActive(btn) ? '#11783C' : '#000',
        fontWeight: isActive(btn) ? 700 : 400,
        borderColor: isActive(btn) ? "#11783C" : "#e0e0e0"
    })

    const readContact = async(pageToFetch) => {
        if (pageToFetch === 1) {
            setListLoader(true)
        }
        const r = await rqx.get(`<<tool>>/${env()}/contact/read`, {company_id: __SESSION.data.uaccess[0].company_id, page: pageToFetch, limit: 10, type: subtype, search: search  })
        setTotalList(r.total)
        if (r.data.length < 10) {
            setHasMore(false)
        }else{
            setHasMore(true)
        }
        if (pageToFetch === 1) {
            setList(r.data)
        }else{
            setList((p) => [...p, ...r.data])
        }
        setPage(pageToFetch + 1)
        setListLoader(false)
    }

    const loadMoreData = () => {
        readContact(page)
    }

    useEffect(() => {
        if (search !== '') {
            setListLoader(true)
            setList([])
            const searchFcn = setTimeout(() => {
                readContact(1)
            }, 500)
            return () => clearTimeout(searchFcn)
        }else{
            readContact(1)
        }
        // eslint-disable-next-line
    },[urlParams.get('subft'), search])
    
    return (
         <Box height="100vh" width="100%" display="flex" flexDirection="column" gap="24px" mt={2} className="overflowY">
            <Stack direction="row" spacing={2}>
                {
                    btnSubFt.map((v,k) => (
                        <Button variant="outlined" sx={() => btnStyle(v.url)} onClick={() => handleBtns(v.url)} key={k}>
                            {v.name}
                        </Button>
                    ))
                }
            </Stack>
            <Stack direction="row" justifyContent="space-between">
                <TextField size="small" type="search" sx={{bgcolor: "#fff"}} label="Search" 
                    onChange={(e) => setSearch(e.target.value)}
                    value={search}
                />
                <Button variant="contained" onClick={handleAdd}>
                    Add Single Contact
                </Button>
            </Stack>
            <List list={list} listLoader={listLoader} setForm={setForm} setAdd={setAdd} loadMoreData={loadMoreData} hasMore={hasMore} tool_state={tool_state} totalList={totalList} />
            {
                add &&
                    <Setup add={add} setAdd={setAdd} form={form} setForm={setForm} tool_state={tool_state} dfltForm={dfltForm} setList={setList} subtype={subtype} />
            }
        </Box>
    )
}
